import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { CurrentLanguageInterceptor } from '../interceptors/current-language.interceptor';

/**
 *
 * @param standaloneInterceptors use false in legacy applications importing `HttpClientModule`, true in standalone applications using `provideHttpClient(withInterceptors(currentLanguageInterceptor))`
 * @returns
 */
export const provideCurrentLanguage = (
    standaloneInterceptors = true,
): EnvironmentProviders =>
    makeEnvironmentProviders([
        standaloneInterceptors
            ? CurrentLanguageInterceptor
            : {
                  provide: HTTP_INTERCEPTORS,
                  useClass: CurrentLanguageInterceptor,
                  multi: true,
              },
    ]);
